(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const html = document.documentElement;
  html.classList.add('nx-motion-ready');

  const progress = document.createElement('div');
  progress.className = 'nx-motion-progress';
  progress.setAttribute('aria-hidden', 'true');
  document.body.appendChild(progress);

  let scrollTicking = false;
  const updateProgress = () => {
    const max = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
    progress.style.transform = `scaleX(${Math.min(1, Math.max(0, window.scrollY / max))})`;
    scrollTicking = false;
  };
  window.addEventListener('scroll', () => {
    if (!scrollTicking) {
      scrollTicking = true;
      requestAnimationFrame(updateProgress);
    }
  }, { passive: true });
  updateProgress();

  const revealSelector = [
    '.nx__hero > *', '.nx__featured > *', '.nx__subheading', '.nx__card', '.nx__process > *',
    '.nxr__header', '.nxr__card', '.nxp__media', '.nxp__details', '.nxp__proof article',
    '.nxp__below > section', '.nxp__feature-card', '.nxp__faq details', '.nxc__panel',
    '.nexor-footer > *', '[data-nx-reveal]'
  ].join(',');

  let observer;
  const reveal = (scope = document) => {
    const nodes = [...scope.querySelectorAll(revealSelector)];
    nodes.forEach((node, index) => {
      if (node.dataset.nxMotionBound === 'true') return;
      node.dataset.nxMotionBound = 'true';
      node.setAttribute('data-nx-reveal', '');
      const explicitDelay = Number(node.dataset.nxDelay || 0);
      node.style.setProperty('--nx-delay', `${explicitDelay || Math.min((index % 6) * 65, 325)}ms`);
      if (reduceMotion || !observer) node.classList.add('nx-is-visible');
      else observer.observe(node);
    });
  };

  if (!reduceMotion && 'IntersectionObserver' in window) {
    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('nx-is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -7% 0px', threshold: 0.08 });
  }
  reveal();

  document.addEventListener('nexor:content-loaded', (event) => reveal(event.detail?.root || document));
  document.addEventListener('shopify:section:load', (event) => reveal(event.target || document));

  if (finePointer && !reduceMotion) {
    window.addEventListener('pointermove', (event) => {
      html.style.setProperty('--nx-pointer-x', `${event.clientX}px`);
      html.style.setProperty('--nx-pointer-y', `${event.clientY}px`);
    }, { passive: true });

    const tiltSelector = '.nx__featured,.nx__card,.nxr__card,.nxp__feature-card,.nxp__proof article';
    const bindTilt = (scope = document) => {
      scope.querySelectorAll(tiltSelector).forEach((card) => {
        if (card.dataset.nxTiltBound === 'true') return;
        card.dataset.nxTiltBound = 'true';
        card.addEventListener('pointermove', (event) => {
          const rect = card.getBoundingClientRect();
          const x = (event.clientX - rect.left) / rect.width;
          const y = (event.clientY - rect.top) / rect.height;
          card.style.setProperty('--nx-tilt-y', `${(x - .5) * 4.2}deg`);
          card.style.setProperty('--nx-tilt-x', `${(.5 - y) * 4.2}deg`);
          card.style.setProperty('--nx-card-x', `${x * 100}%`);
          card.style.setProperty('--nx-card-y', `${y * 100}%`);
        });
        card.addEventListener('pointerleave', () => {
          card.style.setProperty('--nx-tilt-x', '0deg');
          card.style.setProperty('--nx-tilt-y', '0deg');
        });
      });
    };
    bindTilt();
    document.addEventListener('nexor:content-loaded', (event) => bindTilt(event.detail?.root || document));
    document.addEventListener('shopify:section:load', (event) => bindTilt(event.target || document));
  }
})();
